import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const ConvictionCandleLine = ({
  candleDuration,
  priceToBreakLong,
  priceToBreakShort,
  priceToBreak,
  size,
  scaleY,
  portalRef,
}) => {
  let bothDirections;
  if (priceToBreakLong > 0) bothDirections = true;
  else bothDirections = false;

  const json = {
    Category: 'Setup',
    Type: 'Conviction Candle',
    'Candle Duration': candleDuration,
    'Break Price': ApplyRounding(Number(priceToBreak), 2),
  };

  const jsonLong = {
    Category: 'Setup',
    Type: 'Conviction Candle',
    'Candle Duration': candleDuration,
    'Break Price Long': ApplyRounding(Number(priceToBreakLong), 2),
  };
  const jsonShort = {
    Category: 'Setup',
    Type: 'Conviction Candle',
    'Candle Duration': candleDuration,
    'Break Price Short': ApplyRounding(Number(priceToBreakShort), 2),
  };

  return (
    <>
      {scaleY ? (
        <>
          {bothDirections ? (
            <>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreakLong))}
                y2={scaleY(Number(priceToBreakLong))}
              ></line>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreakShort))}
                y2={scaleY(Number(priceToBreakShort))}
              ></line>
              <HoverBox
                json={jsonLong}
                topBoundary={scaleY(Number(priceToBreakLong)) - 2}
                bottomBoundary={scaleY(Number(priceToBreakLong)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
              />
              <HoverBox
                json={jsonShort}
                topBoundary={scaleY(Number(priceToBreakShort)) - 2}
                bottomBoundary={scaleY(Number(priceToBreakShort)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
              />
            </>
          ) : (
            <>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              ></line>
              <HoverBox
                json={json}
                topBoundary={scaleY(Number(priceToBreak)) - 2}
                bottomBoundary={scaleY(Number(priceToBreak)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
              />
            </>
          )}
        </>
      ) : null}
    </>
  );
};

ConvictionCandleLine.propTypes = {
  breakBy: PropTypes.any,
  candleDuration: PropTypes.any,
  priceToBreak: PropTypes.number,
  priceToBreakLong: PropTypes.any,
  priceToBreakShort: PropTypes.any,
  quantityBasisValue: PropTypes.any,
  scaleY: PropTypes.func,
  size: PropTypes.any,
  portalRef: PropTypes.object,
};
